// Design-only recommendations and proposals. These have no production data source yet.
// Keep them isolated from the GraphQL-backed usage tables and never render them for live responses.
export const REVIEW_PREVIEW_ITEMS = [
  {
    id: 'certificates',
    teamId: 'preview-commercial',
    kind: 'Duplication',
    title: 'Certificates',
    detail: '14 skills doing the same job · 604 runs split between them',
  },
  {
    id: 'policy-check',
    teamId: 'preview-commercial',
    kind: 'Replaced',
    title: '/policy-check',
    detail: 'Shared skill down to 2 runs · 133 moved to three personal versions',
  },
  {
    id: 'renewal',
    teamId: 'preview-commercial',
    kind: 'Replaced',
    title: '/renewal-request',
    detail: 'Shared skill down to 4 runs · 143 moved to Adnan Shaikh’s version',
  },
  {
    id: 'submissions',
    teamId: 'preview-benefits',
    kind: 'Duplication',
    title: 'Submissions',
    detail: '3 skills doing the same job · 88 runs',
  },
  {
    id: 'loss-runs',
    teamId: 'preview-benefits',
    kind: 'Duplication',
    title: 'Loss run summaries',
    detail: '2 skills doing the same job · 34 runs',
  },
  {
    id: 'abandoned',
    teamId: 'preview-commercial',
    kind: 'Abandoned',
    title: '4 shared skills nobody is running',
    detail: '/Surety Bond Recap · /Marine Cargo Checklist · /Submission Email Draft · +1 more',
  },
] as const;

export const PROPOSAL_PREVIEW_ITEMS = [
  {
    id: 'renewal-proposal',
    teamId: 'preview-commercial',
    person: 'Adnan Shaikh',
    action: 'improve',
    skill: '/Renewal Timeline Builder',
    detail:
      'The current one misses the pre-renewal notice. I’ve been using my own version for a month — it’s run 143 times.',
  },
  {
    id: 'certificate-proposal',
    teamId: 'preview-benefits',
    person: 'Priya Nair',
    action: 'share',
    skill: '/coi-generator',
    detail: 'Built this for CS but placement has been asking for it. Worth making it shared?',
  },
] as const;
